












import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { jointGoodsModelProvider } from '../model'

export default defineClassComponent(
  () =>
    class {
      jointGoodsModel = jointGoodsModelProvider.inject()

      handleShareClick = () => {
        dcb.share({
          ...this.jointGoodsModel.value.shareParams,
          url: location.href,
        })
      }
    },
)
